import { StarIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

interface StarRatingProps {
  value: number
  size?: 'sm' | 'md'
  className?: string
}

export function StarRating({ value, size = 'sm', className }: StarRatingProps) {
  const starSize = size === 'sm' ? 'h-3 w-3' : 'h-4 w-4'
  const stars = []

  for (let i = 1; i <= 5; i++) {
    const filled = value >= i
    const half = !filled && value >= i - 0.5

    stars.push(
      <StarIcon
        key={i}
        className={cn(
          starSize,
          filled
            ? 'fill-amber-400 text-amber-400'
            : half
              ? 'fill-amber-400/50 text-amber-400'
              : 'fill-transparent text-muted-foreground/30'
        )}
      />
    )
  }

  return <div className={cn('flex items-center gap-0.5', className)}>{stars}</div>
}
